export default class HeaderMenu {
	constructor(breakpoint = 1101) {
		this.breakpoint = breakpoint;
		this.burgerMenu = '.site-header__burgerBtn';
		this.closeMenu = '.close-menu, .site-header__menu-closer';
		this.header = '.site-header';
		this.menuWrap = '.site-header__wrap';
		this.mobileBtn = '.header-menu__listItem.menu-item-has-children';
		this.mobileSubmenu = '.mega-menu, .header-menu__sub-list';

		this.resizeEvent = null;
		this.toggleMenuEvent = null;
		this.toggleMobileLinkEvent = null;
	}

	init() {
		this.resizeEvent = this.hideMobileMenu.bind(this);
		this.toggleMenuEvent = this.toggleMobileMenu.bind(this);
		// this.toggleMobileLinkEvent = this.toggleMobileLink.bind(this);

		$('body').on('click', this.burgerMenu, this.toggleMenuEvent);
		$('body').on('click', this.closeMenu, this.toggleMenuEvent);
		// $("body").on("click", this.mobileBtn, this.toggleMobileLinkEvent);

		window.addEventListener('resize', this.resizeEvent, false);
	}

	hideMobileMenu() {
		if (window.innerWidth > this.breakpoint) {
			// $(this.header).removeClass("open-menu");
			$(this.menuWrap).removeAttr('style');
			$(this.mobileBtn).removeClass('header-menu__listItem--open');
			$(this.mobileSubmenu).removeAttr('style');
		}
	}

	toggleMobileMenu() {
		$(this.header).toggleClass('open-menu');
		$(this.menuWrap).fadeToggle(200);
		$('.site-header__menu-closer').fadeToggle();
		$('body').toggleClass('no-scroll');
	}

	// toggleMobileLink(event) {
	// if (!$(event.target).hasClass('menu-item-has-children')) return;

	// $(event.currentTarget)
	// .toggleClass('header-menu__listItem--open')
	// .find(this.mobileSubmenu)
	// .slideToggle(function() {
	// $(event.currentTarget).parent();
	// });
	// }

	destroy() {
		$('body').off('click', this.burgerMenu, this.toggleMenuEvent);
		$('body').off('click', this.mobileBtn, this.toggleMobileLinkEvent);

		window.removeEventListener('resize', this.scrollingEvent, false);
	}
}
